import { styled } from "@acko-tech/building-blocks.ui.common";

export const Wrapper = styled.div`
  width: 100%;
`;

export const CardsContainer = styled.div`
  margin: 20px 0;
`;

export const CardWrapper = styled.div`
  display: flex;
  padding: 16px 0px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f8f9fa;
  }

  @media (min-width: 768px) {
    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }
`;

export const CardLabel = styled.div`
  color: var(--text-primary-n-600, #040222);

  /* Paragraph/Small */
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;

export const InfoCard = styled.div`
  border-radius: 16px;
  background: #f3f3ff;
  backdrop-filter: blur(7px);
  padding: 16px;
`;

export const InfoCardMedia = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const InfoCardTitle = styled.div`
  color: #0a0a0a;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  text-align: center;
  padding: 4px 20px 20px 20px;
`;

export const ArrowIconWrapper = styled.div`
  position: relative;
  left: 100px;
`;

export const VariantMessage = styled.div`
  color: var(--Neutral-N400, #5B5675);
  text-align: center;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;
